module.exports = __webpack_public_path__ + "img/vi.9226a25c.svg";